import React from 'react';
import PropTypes from 'prop-types';
import { decodeString } from '../../../utils/helper';

function DetailBlock(props){
    const { title,
        value } = props;
    return(<div className="profile-view__details__block__personal__block">
        <p className="profile-view__details__block__personal__title">{decodeString(title)}</p>
        <p className="profile-view__details__block__personal__description">{decodeString(value) || '--'}</p>
    </div>)
}

DetailBlock.propTypes = {
    title: PropTypes.string,
}

export default DetailBlock;